export default __webpack_public_path__ + "static/media/circled-warning-white.1b583d70.svg";